import {Component, inject, OnInit, signal} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {TsExportService} from '../../services/ts-export.service';
import {DownloadService} from '../../services/download.service';
import {formatDate} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastService} from '../../services/toast.service';
import {finalize} from 'rxjs';

@Component({
  selector: 'app-ts-export',
  templateUrl: './ts-export.component.html',
  imports: [
    ReactiveFormsModule
  ],
  standalone: true
})
export class TsExportComponent implements OnInit{

  private fb = inject(UntypedFormBuilder);
  private service = inject(TsExportService);
  private download = inject(DownloadService);
  public form!: UntypedFormGroup;
  public loading = signal(false);
  public toast = inject(ToastService);

  ngOnInit(): void {
    const now = new Date(Date.now());
    this.form = this.fb.group({
      month: [formatDate(now, 'YYYY-MM', 'en-US'), [Validators.required]],
    });
  }

  onSubmit({value, valid}: { value: any, valid: boolean }): void {
    if (!valid) {
      this.form.markAllAsTouched();
      return;
    }

    if (!this.loading()) {
      this.loading.set(true);
      this.service.download(value)
        .pipe(finalize(() => this.loading.set(false)))
        .subscribe({
          next: (result) => {
            const name = "export_team_system_" + (value.month as string).replace('-', '_');
            this.download.downloadBlobFile(result, name, '.txt');
            this.toast.show('Esportazione completata', 'success');
          },
          error: (error: HttpErrorResponse) => {
            this.toast.show('Errore durante l\'esportazione', 'error');
          }
        });
    }
  }
}
